(() => {
  function initialize(root) {
    if (root.classList.contains('is-ready')) return;
    const tabs = [...root.querySelectorAll('[data-info-tab]')];
    const panels = [...root.querySelectorAll('[data-info-panel]')];
    const nav = root.querySelector('.cotigo-info__nav');
    const desktop = matchMedia('(min-width:750px)');
    let active = panels[0]?.dataset.infoPanel;
    const select = (key, focus = false) => {
      active = key;
      panels.forEach(panel => { panel.open = panel.dataset.infoPanel === key; });
      tabs.forEach(tab => {
        const selected = tab.dataset.infoTab === key;
        tab.setAttribute('aria-selected', String(selected));
        tab.tabIndex = selected ? 0 : -1;
        if (selected && focus) tab.focus();
      });
    };
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => select(tab.dataset.infoTab));
      tab.addEventListener('keydown', event => {
        let target;
        if (event.key === 'ArrowDown') target = (index + 1) % tabs.length;
        if (event.key === 'ArrowUp') target = (index + tabs.length - 1) % tabs.length;
        if (event.key === 'Home') target = 0;
        if (event.key === 'End') target = tabs.length - 1;
        if (target !== undefined) { event.preventDefault(); select(tabs[target].dataset.infoTab, true); }
      });
    });
    panels.forEach(panel => {
      panel.addEventListener('toggle', () => {
        if (desktop.matches || !panel.open) return;
        active = panel.dataset.infoPanel;
        panels.forEach(other => { if (other !== panel) other.open = false; });
      });
    });
    const sync = () => {
      if (desktop.matches) {
        nav.setAttribute('role', 'tablist');
        nav.setAttribute('aria-orientation', 'vertical');
        tabs.forEach(tab => tab.setAttribute('role', 'tab'));
        panels.forEach(panel => {
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', 'InfoTab-' + root.id.slice('CotigoInfo-'.length) + '-' + panel.dataset.infoPanel);
        });
        select(active || panels[0].dataset.infoPanel);
      } else {
        nav.removeAttribute('role');
        tabs.forEach(tab => tab.removeAttribute('role'));
        panels.forEach(panel => { panel.removeAttribute('role'); panel.removeAttribute('aria-labelledby'); });
      }
    };
    desktop.addEventListener('change', sync);
    root.classList.add('is-ready');
    sync();
  }
  const scan = () => document.querySelectorAll('.cotigo-info').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
  document.addEventListener('shopify:section:load', scan);
})();
